/**
 * Warwick Design System - Typography Tokens
 * Font sizes, weights, and line heights based on design specs
 * All sizes converted from pixels to rem (16px = 1rem)
 */

// Font weights
export const fontWeights = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 800,
};

// Font sizes (converted from design specs)
export const fontSizes = {
  // Main display sizes
  hero: '2.5rem',        // 40px - Middle card titles
  large: '2.375rem',     // 38px - Weather and time display
  title: '1.6875rem',    // 27px - Welcome text and name
  subtitle: '1.625rem',  // 26px - Middle card descriptions
  body: '1.5rem',        // 24px - WiFi connect text
  bodySmall: '1.25rem',  // 20px - Scan QR code text
  caption: '1.125rem',   // 18px - Room number text
  tiny: '0.75rem',       // 12px - Room type and floor text

  // Legacy sizes for transition
  s: '0.5rem',
  m: '1rem',
  ml: '1.25rem',
  l: '1.5rem',
  xl: '1.75rem',
  xxl: '2rem',
};

// Line heights for better readability
export const lineHeights = {
  tight: 1.2,
  normal: 1.4,
  relaxed: 1.6,
  loose: 1.8,
};

// Typography scale with semantic naming
export const typography = {
  // Weather and time display
  weatherTime: {
    fontSize: fontSizes.large,      // 38px
    fontWeight: fontWeights.medium, // 500
    lineHeight: lineHeights.tight,
  },

  // Welcome section
  welcomeHeading: {
    fontSize: fontSizes.title,      // 27px
    fontWeight: fontWeights.bold,   // 800
    lineHeight: lineHeights.tight,
  },
  
  guestName: {
    fontSize: fontSizes.title,      // 27px
    fontWeight: fontWeights.regular, // 400
    lineHeight: lineHeights.tight,
  },

  // Room information
  roomNumber: {
    fontSize: fontSizes.caption,    // 18px
    fontWeight: fontWeights.regular, // 400
    lineHeight: lineHeights.normal,
  },

  roomDetails: {
    fontSize: fontSizes.tiny,       // 12px
    fontWeight: fontWeights.regular, // 400
    lineHeight: lineHeights.normal,
  },

  // WiFi section
  wifiHeading: {
    fontSize: fontSizes.body,       // 24px
    fontWeight: fontWeights.regular, // 400
    lineHeight: lineHeights.normal,
  },

  qrCodeText: {
    fontSize: fontSizes.bodySmall,  // 20px
    fontWeight: fontWeights.regular, // 400
    lineHeight: lineHeights.normal,
  },

  // Service cards
  serviceTitle: {
    fontSize: fontSizes.hero,       // 40px
    fontWeight: fontWeights.semiBold, // 600
    lineHeight: lineHeights.tight,
  },

  serviceDescription: {
    fontSize: fontSizes.subtitle,   // 26px
    fontWeight: fontWeights.regular, // 400
    lineHeight: lineHeights.normal,
  },

  // General purpose styles
  heading: {
    fontSize: fontSizes.title,
    fontWeight: fontWeights.semiBold,
    lineHeight: lineHeights.tight,
  },

  body: {
    fontSize: fontSizes.body,
    fontWeight: fontWeights.regular,
    lineHeight: lineHeights.normal,
  },

  caption: {
    fontSize: fontSizes.caption,
    fontWeight: fontWeights.regular,
    lineHeight: lineHeights.normal,
  },
};
